// @avantia common-code
import { HpCustomExtensionFunctionTypes, HpCustomExtensionTypes } from './customExtensionRegistryTypes';

const funcMap = new Map<HpCustomExtensionTypes, HpCustomExtensionFunctionTypes>();

export function registerCustomExtension(
  name: HpCustomExtensionTypes,
  extensionFunction: HpCustomExtensionFunctionTypes
): void {
  funcMap.set(name, extensionFunction);
}

export function getCustomExtension<FunctionT extends HpCustomExtensionFunctionTypes>(
  name: HpCustomExtensionTypes
): FunctionT | undefined {
  return funcMap.get(name) as FunctionT;
}
